import { useAppSelector } from '@/hooks/use-app-selector'
import { IMultiLevelMenu } from '@/interfaces/interfaces'
import React from 'react'
import { Navigation } from '../Base/Navigation/Navigation'
export const ScenarioAnalysisReportNavigation: React.FC = () => {
  const reportId = useAppSelector((s) => s.axiomReport.selectedReport.reportId)

  const ScenarioOverviewMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Scenario Overview',
    isMenuList: false,
    route: `/reports/${reportId}/scenario-analysis/dashboard`,
  }
  const SecurityDetailsMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Security Details',
    isMenuList: false,
    route: `/reports/${reportId}/scenario-analysis/security-details`,
  }

  const headerMenuItems: IMultiLevelMenu[] = [
    ScenarioOverviewMenu,
    SecurityDetailsMenu,
  ]
  return (
    <Navigation
      headerMenuItems={headerMenuItems}
      highlightActive={true}
      paddingHorizontal={0}
    />
  )
}
